// ══════════════════════════════════════════════════════
//  CONTRASEÑA — reglas y textos en un solo sitio del frontend
//  Son las MISMAS que valida la API (Api-goodappetite/src/utils/validators.js →
//  errorPassword, REQUISITOS_PASSWORD y MENSAJE_PASSWORD): si cambias una, cambia la otra.
//  Entre 8 y 64 caracteres (NFC), al menos una letra (también ñ y tildes) y al menos un
//  número, y como mucho 72 bytes (límite de bcrypt). Cualquier otro carácter vale.
//  Lo usan el registro, el cambio de contraseña y restablecer contraseña.
// ══════════════════════════════════════════════════════

export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 64;

// Misma contraseña escrita en otro teclado («á» como 1 o 2 caracteres) → misma forma
const normalizar = (p) => String(p || "").normalize("NFC");

// Caracteres reales: un emoji cuenta 1, no 2
export const largoPassword = (p) => [...normalizar(p)].length;

export const MENSAJE_PASSWORD = `La contraseña debe tener entre ${PASSWORD_MIN} y ${PASSWORD_MAX} caracteres, al menos una letra y al menos un número. Puedes usar símbolos y espacios.`;

export const REQUISITOS_PASSWORD = [
  {
    id: "largo",
    texto: `Entre ${PASSWORD_MIN} y ${PASSWORD_MAX} caracteres`,
    cumple: (p) => largoPassword(p) >= PASSWORD_MIN && largoPassword(p) <= PASSWORD_MAX,
  },
  { id: "letra", texto: "Al menos una letra (vale la ñ y las tildes)", cumple: (p) => /\p{L}/u.test(normalizar(p)) },
  { id: "numero", texto: "Al menos un número", cumple: (p) => /\d/.test(normalizar(p)) },
];

// Nota informativa (no es un requisito): se enseña debajo de la lista
export const NOTA_PASSWORD = "Puedes usar símbolos y espacios.";

// bcrypt (en la API) solo usa los primeros 72 bytes: una ñ o una tilde ocupan 2 y un
// emoji 4, así que 64 caracteres pueden pasarse. Mismo texto que la API.
export const PASSWORD_MAX_BYTES = 72;
export const MENSAJE_PASSWORD_BYTES =
  "La contraseña es demasiado larga para guardarla de forma segura: las tildes, la ñ y los emojis ocupan más que una letra normal. Acórtala un poco.";

export const bytesPassword = (p) => new TextEncoder().encode(normalizar(p)).length;
export const superaBytes = (p) => bytesPassword(p) > PASSWORD_MAX_BYTES;

// "" si vale; si no, el mismo mensaje que daría la API
export const errorPassword = (p) => {
  if (!REQUISITOS_PASSWORD.every((r) => r.cumple(p))) return MENSAJE_PASSWORD;
  if (superaBytes(p)) return MENSAJE_PASSWORD_BYTES;
  return "";
};

export const passwordValida = (p) => errorPassword(p) === "";

// Fuerza orientativa (0 a 4) dentro de lo que admite la API
export const fuerzaPassword = (p) => {
  if (!p) return { nivel: 0, texto: "" };
  if (!passwordValida(p)) return { nivel: 0, texto: "No cumple los requisitos" };
  const largo = largoPassword(p);
  let puntos = 1;
  if (largo >= 12) puntos++;
  // Mezcla de tipos: minúsculas, mayúsculas, símbolos o espacios
  const tipos = [/\p{Ll}/u, /\p{Lu}/u, /[^\p{L}\d]/u].filter((r) => r.test(p)).length;
  if (tipos >= 2) puntos++;
  if (largo >= 16 || (tipos === 3 && largo >= 10)) puntos++;
  const textos = ["", "Aceptable", "Buena", "Fuerte", "Muy fuerte"];
  return { nivel: Math.min(puntos, 4), texto: textos[Math.min(puntos, 4)] };
};
